export var SearchBoxStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects, palette = theme.palette;
    return {
        root: [
            {
                borderRadius: effects.roundedCorner2,
                borderColor: palette.neutralSecondaryAlt,
            },
        ],
    };
};
//# sourceMappingURL=SearchBox.styles.js.map